import { render, staticRenderFns } from "./AbilityScoresPanel.vue?vue&type=template&id=22085779&scoped=true"
import script from "./AbilityScoresPanel.vue?vue&type=script&lang=js"
export * from "./AbilityScoresPanel.vue?vue&type=script&lang=js"
import style0 from "./AbilityScoresPanel.vue?vue&type=style&index=0&id=22085779&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22085779",
  null
  
)

export default component.exports